import React, {useState} from "react";
import axios from "axios";
import { baseURL } from "services/API";
import UnoccupiedUnitsTable from "../../components/Tables/UnoccupiedUnitsTable";
import DummyTable from "components/DummyViews/DummyTable";
import { Grid, Box, Typography } from "@mui/material";
import { useUnoccupiedRentalUnits } from "services/hooks/rentals";
import { useNavigate } from "react-router-dom";
import ProgressScale from "components/ProgressScale";
import UnoccupiedUnitsPopover from "components/PopOvers/UnoccupiedUnitsPopover";
import FormDialog from "components/modal";
import AddTenantsFromUnoccupiedForm from "components/Forms/AddTenantsFromUnoccupiedListForm";
import * as yup from 'yup';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setRefreshCount } from "state";
import TopSnack from "components/TopSnack";

const UnoccupiedUnits = ({propertyDetails}) => {
  const navigate = useNavigate();

	const [activeUnit, setActiveUnit] = useState("")
	const [modal, setModal] = React.useState("");
	const dispatch = useDispatch();
	const property_id = useSelector((state) => state.property_id);
	const [anchorEl, setAnchorEl] = useState(null);
	const openPopper = Boolean(anchorEl);
	const popperId = openPopper ? "simple-popover" : undefined;
	const [details, setDetails] = React.useState("");
	const [open, setOpen] = React.useState(false);
  	const { unoccupiedRentalUnits, isLoadingUnoccupiedRentalUnits, error } = useUnoccupiedRentalUnits(property_id);
	const [message, setMessage] = React.useState("");
	const [openSnack, setOpenSnack] = React.useState({open: false,vertical: "top",horizontal: "center"});
	const [severity, setSeverity] = React.useState("");
	const [isLoadedUnits, setIsLoadedUnits] = React.useState(false);
	const [tenantDetails, setTenantDetails] = React.useState({});
	const [loadedTenant, setLoadedTenant] = React.useState(false);
	const [loadingTenantsError, setLoadingTenantsError] = React.useState("");
	const [isExistingTenant, setIsExisitingTenant] = React.useState(true);
	const [loadingTenantDetails, setLoadingTenantDetails] = React.useState(true);
	const [errorLoadingTenantDetails, setErrorLoadingTenantDetails] = React.useState(false);
	const [newTenantDetails, setNewTenantDetails] = React.useState({next_payment_date:moment().add(1, 'day').format('YYYY-MM-DD'),start_date:moment().format('YYYY-MM-DD'), expected_payment_date: moment().format('YYYY-MM-DD'),first_name: "",last_name: "",tenant_number: "",phone_number:"",unit_id: "", rent_backlog_description:"", rent_backlog_amount:0,});

	const [isBrandNewTenant, setIsBrandNewTenant] = React.useState(true);
	const [hasPaymentBacklog, setHasPaymentBacklog] = React.useState(false);
	const [isInitialPaymentMade, setIsInitialPaymentMade] = React.useState(false);
	const [isOutstandingBalance, setIsOutstandingBalance] = React.useState(true);

	const handleHasPaymentBacklog = () =>{
		setHasPaymentBacklog(!hasPaymentBacklog);
		setNewTenantDetails((prev) => ({ ...prev, has_payment_backlog: !hasPaymentBacklog }));
	}

	const handleChangeTenantType = (e) => {
		setIsBrandNewTenant(e);
		if (e){
			setNewTenantDetails((prev) => ({ ...prev, is_brand_new_tenant: e, has_payment_backlog: false }));
		} else {
			setNewTenantDetails((prev) => ({ ...prev, is_brand_new_tenant: e }));
		}
	};

	const handleChangeIsInitialPaymentMade = ()=>{
		setIsInitialPaymentMade(!isInitialPaymentMade);
		setNewTenantDetails((prev) => ({ ...prev, is_initial_payment_made: !isInitialPaymentMade }));
	}

	const handleChangeBalanceType = (status) =>{
		setIsOutstandingBalance(status);
		setNewTenantDetails((prev) => ({ ...prev, is_rent_backlog_outstanding: status, is_rent_backlog_carried:!status, rent_backlog_amount:0 }));
		
	}


	const handleCloseSnack = (event, reason) => {
		if (reason === "clickaway") {
		return;
		}
		setOpenSnack({ ...openSnack, open: false });
	};

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClickPopOver = (event, row) => {
		setAnchorEl(event.currentTarget);
		setActiveUnit(row);
	};

	const handleClosePopOver = () => {
		setAnchorEl(null);
	};

	const handleModalView = (modalView) => {
		if(modalView==='addTenant'){
			setNewTenantDetails((prev) => ({ 
				...prev, 
				unit_id: details.id,
				is_initial_payment_made: isInitialPaymentMade,
				periods_covered_initially: details.down_payment_periods_covered,
				is_brand_new_tenant: isBrandNewTenant, 
				has_payment_backlog: hasPaymentBacklog,
				is_rent_backlog_carried: !isOutstandingBalance,
				is_rent_backlog_outstanding: isOutstandingBalance,
				security_deposit_amount: details.unit_rent_security_fee,
				rent_amount_paid: details.unit_cycle_down_payment,
				total_deposit_amount: parseFloat(details.unit_cycle_down_payment) + parseFloat(details.unit_rent_security_fee)})
			);
		}
		setModal(modalView);
	};

	const handleClose = () => {
		setModal("");
		setErrors({});
		setOpen(false);
		setLoadedTenant(false);
		setIsExisitingTenant(true);
		setIsLoadedUnits(false);
		setIsInitialPaymentMade(false);
		setHasPaymentBacklog(false);
		setIsBrandNewTenant(true);
		setIsOutstandingBalance(true);
		setNewTenantDetails({rent_deposit_amount: 0, next_payment_date:moment().add(1, 'day').format('YYYY-MM-DD'), start_date:moment().format('YYYY-MM-DD'),expected_payment_date: moment().format('YYYY-MM-DD'), first_name: "",last_name: "",tenant_number: "",phone_number:"",unit_id: "",rent_backlog_description:"",rent_backlog_amount:0});
	};

	const handleChangeTenantDetails = (event) => {
		const { name, value } = event.target;
    	setNewTenantDetails((prev) => ({ ...prev, [name]: value }));
		if (!toString(value).trim()) {
      		setErrors((prev) => ({ ...prev, [name]: `${name} is required`}));
		} else {
			setErrors((prev) => ({ ...prev, [name]: '' }));
		}
	};

	const handleChangeSecurityDeposit = (e) =>{
		const {value} = e.target
		setNewTenantDetails((prev) => ({ ...prev, security_deposit_amount : value, total_deposit_amount: parseFloat(value) + parseFloat(prev.rent_amount_paid) }));

	}

	const handleChangePeriodsCovered=(e)=>{
		const {value} = e.target
		const rentAmount = parseFloat(value) * parseFloat(details.unit_rent); 
		setNewTenantDetails((prev) => ({ ...prev, periods_covered_initially : value, rent_amount_paid: rentAmount, total_deposit_amount: rentAmount + parseFloat(prev.security_deposit_amount) }));
	}

	const handleChangeTenantNumber = async (e) => {
		setLoadedTenant(false);
		setIsExisitingTenant(true);
		setIsLoadedUnits(false);
		setLoadingTenantsError("");
		setNewTenantDetails((prev) => ({ ...prev, first_name: "", last_name: "" }));
		const phone_number = e.target.value;
		if (!phone_number.trim()) {
      		setErrors((prev) => ({ ...prev, 'phone_number': `The Tenant's phone number is required`}));
		} else {
			setErrors((prev) => ({ ...prev, 'phone_number': '' }));
		}
		if (phone_number.length === 12) {
			setNewTenantDetails((prev) => ({ ...prev, 'phone_number': phone_number }));
			try {
				const response = await axios.get(`${baseURL}/tenants?username=${phone_number}`);
				setTenantDetails(response.data.data);
				setNewTenantDetails((prev)=> ({...prev, tenant_number: response.data.data.tenant_number, tenant_id: response.data.data.id}))
				setLoadedTenant(true);
				setLoadingTenantDetails(false);
				setLoadingTenantsError("");
				return true;
			} catch (err) {
				setIsExisitingTenant(false);
				setLoadingTenantDetails(false);
				setErrorLoadingTenantDetails(true);
				setLoadingTenantsError("");
				return false;
			}
		} else {
			setLoadingTenantsError("Please type a complete phone number with 12 digits including 256");
			setNewTenantDetails((prev) => ({ ...prev, first_name: "", last_name: "" }));
			
		}
	};

	const handleSubmitDelete = async () => {
    try {
      const response = await axios.delete(`${baseURL}/landlords/rentals/units/delete?unit_id=${activeUnit}`);

      setOpenSnack({ ...openSnack, open: true });
      setSeverity("success");
      setMessage("Unit Deleted Successfully");
      dispatch(setRefreshCount());
    } catch (err) {
      setOpenSnack({ ...openSnack, open: true });
      setSeverity("error");
      setMessage("Unit Delete failed, Please check unit details");
    }
  };

	const [errors, setErrors] = React.useState({});
	const propertySchema = isExistingTenant ? yup.object().shape({
		unit_id: yup.string().required("Please select a unit attached to the property above"),
		tenant_id: yup.number().required(),
		tenant_number: yup.string().required("Input a the tenant's phone number to start the process"),
		phone_number: yup.string().required("Input a the tenant's phone number to start the process"),
		total_deposit_amount: yup.number().required("This field is required"),
		is_initial_payment_made: yup.boolean().required("This is required"),
		rent_amount_paid:yup.number().required("This is required"),
		periods_covered_initially: yup.number().required("This field is required"),
		rent_backlog_amount: yup.number().when('has_payment_backlog', {
			is: true,
			then: yup.number().min(1, 'Please enter the balance amount').required("This field is required")
		}),
		has_payment_backlog: yup.boolean(),
		is_rent_backlog_outstanding: yup.boolean(),
		is_rent_backlog_carried: yup.boolean(),
		rent_backlog_description: yup.string(),
		start_date: yup.date().required("This field is required"),
		next_payment_date: yup.date().required("This field is required"),
	}) : yup.object().shape({
		unit_id: yup.string().required("Please select a unit attached to the property above"),
		phone_number: yup.string().required("Input a the tenant's phone number to start the process"),
		first_name: yup.string().required("Input the tenant's First Name"),
		last_name: yup.string().required("Input the tenant's Last Name"),
		total_deposit_amount: yup.number().required("This field is required"),
		is_initial_payment_made: yup.boolean().required("This is required"),
		rent_amount_paid:yup.number().required("This is required"),
		periods_covered_initially: yup.number().required("This field is required"),
		rent_backlog_amount: yup.number().when('has_payment_backlog', {
			is: true,
			then: yup.number().min(1, 'Please enter the balance amount').required("This field is required")
		}),
		has_payment_backlog: yup.boolean(),
		rent_backlog_description: yup.string(),
		is_rent_backlog_outstanding: yup.boolean(),
		is_rent_backlog_carried: yup.boolean(),
		start_date: yup.date().required("This field is required"),
		next_payment_date: yup.date().required("This field is required"),

	}) ;

	const handleSubmitTenant = async () => {
		try {
			await propertySchema.validate(newTenantDetails, {abortEarly:false});
		} catch (error) {
			const newError = {}
			error.inner.forEach(err => {
				newError[err.path]=err.message
			})
			// console.log(newError)
			setErrors(newError)
			return
		}
		let createTenant
		try {
			if (!isExistingTenant) {
				createTenant = await axios.post(`${baseURL}/accounts/users`, {
					first_name: newTenantDetails.first_name,
					last_name: newTenantDetails.last_name,
					email: "dummy@email.com",
					phone_number: newTenantDetails.phone_number.slice(3),
					password: "@Rent123",
					username: `+${newTenantDetails.phone_number}`,
        		});
			}
				
			const response = await axios.post(`${baseURL}/landlords/rentals/units/assign`, {
				unit_id: newTenantDetails.unit_id,
				tenant_id: !isExistingTenant ? createTenant.data.data.id : newTenantDetails.tenant_id,
				is_brand_new_tenant: newTenantDetails.is_brand_new_tenant,
				is_initial_payment_made: newTenantDetails.is_initial_payment_made,
				total_deposit_amount: newTenantDetails.total_deposit_amount,
    			security_deposit_amount: newTenantDetails.security_deposit_amount,
				rent_amount_paid: newTenantDetails.rent_amount_paid, 
				periods_covered_initially:newTenantDetails.periods_covered_initially, 
				has_payment_backlog: newTenantDetails.has_payment_backlog,
				rent_backlog_amount: newTenantDetails.rent_backlog_amount,
				rent_backlog_description: newTenantDetails.rent_backlog_description,
				is_rent_backlog_carried: newTenantDetails.is_rent_backlog_carried,
				is_rent_backlog_outstanding: newTenantDetails.is_rent_backlog_outstanding,
				start_date: newTenantDetails.start_date,
				next_payment_date:newTenantDetails.next_payment_date,
				expected_payment_date: newTenantDetails.expected_payment_date
			});

			handleClose();
			setOpenSnack({ ...openSnack, open: true});
			setSeverity("success");
			setMessage("Tenant Added Successfully");
			dispatch(setRefreshCount());
		} catch (err) {
			setOpenSnack({ ...openSnack, open: true});
			setSeverity("error");
			setMessage("Tenant Addition failed, Please check data provided");
		}
	};


	return (
    <Box m="20px">
      <Grid container spacing={2}>
        <Grid item xs={12} spacing={2}>
          {isLoadingUnoccupiedRentalUnits && <ProgressScale />}
          <div style={{ display: "block" }}>
            <Typography variant="h4" fontWeight={"bold"}>
              Unoccupied Units for Property {propertyDetails.rental_name}
            </Typography>
          </div>
          <Grid container>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ marginTop: 3 }}>
                {isLoadingUnoccupiedRentalUnits ? (
                  <DummyTable />
                ) : (
                  <UnoccupiedUnitsTable
                    rows={unoccupiedRentalUnits}
                    isLoadingUnoccupiedRentalUnits={isLoadingUnoccupiedRentalUnits}
                    handleClickPopOver={handleClickPopOver}
                    id={popperId}
                    setDetails={setDetails}
                  />
                )}
              </Grid>
            </Grid>

            <UnoccupiedUnitsPopover
              popperId={popperId}
              openPopper={openPopper}
              anchorEl={anchorEl}
              handleClosePopOver={handleClosePopOver}
              handleClickOpen={handleClickOpen}
              navigate={navigate}
              activeUnit={activeUnit}
              handleModalView={handleModalView}
            />
          </Grid>
        </Grid>
      </Grid>
      {modal === "addTenant" ? (
        <FormDialog
          open={open}
          handleClose={handleClose}
          enableActions={true}
          content={
            <AddTenantsFromUnoccupiedForm
              handleChangeTenantNumber={handleChangeTenantNumber}
              tenant={tenantDetails}
              errorTenant={errorLoadingTenantDetails}
              loadedTenant={loadedTenant}
              errors={errors}
              unit={details}
			  hasPaymentBacklog={hasPaymentBacklog}
			  handleHasPaymentBacklog={handleHasPaymentBacklog}
			  handleChangeIsInitialPaymentMade={handleChangeIsInitialPaymentMade}
			  calculatedValues={newTenantDetails}
              isBrandNewTenant={isBrandNewTenant}
              handleChangeTenantType={handleChangeTenantType}
              handleChangeSecurityDeposit={handleChangeSecurityDeposit}
			  handleChangePeriodsCovered={handleChangePeriodsCovered}
              isExistingTenant={isExistingTenant}
			  isOutstandingBalance={isOutstandingBalance}
			  isInitialPaymentMade={isInitialPaymentMade}
			  handleChangeBalanceType={handleChangeBalanceType}
              handleChangeTenantDetails={handleChangeTenantDetails}
              loadingTenantsError={loadingTenantsError}
            />
          }
          title={`Attach Tenant to ${details.related_rental_unit.unit_name}`}
          handleSubmit={handleSubmitTenant}
          buttonText="submit"
          buttonClass={"add-button"}
        />
      ) : modal === "delete" ? (
        <FormDialog
          title="Delete Unit"
          enableActions={true}
          open={open}
          content="Are you sure you want to delete this Unit?"
          handleClose={handleClose}
          handleSubmit={handleSubmitDelete}
          buttonText="Delete Unit"
        />
      ) : null}
      <TopSnack
        vertical={openSnack.vertical}
        horizontal={openSnack.horizontal}
        open={openSnack.open}
        handleCloseSnack={handleCloseSnack}
        message={message}
        severity={severity}
      />
    </Box>
  );
};

export default UnoccupiedUnits;
